import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toggleValue'
})
export class ToggleValuePipe implements PipeTransform {

  transform(value: number): string {

    if (value === 0) {
      return "Y";
    } else if (value === 1) {
      return "N";
    } else {
      return "-";
    }

  }

}
